/** Spinner.tsx — lightweight busy indicator. */
import React from 'react';

export default function Spinner({ label }: { label?: string }) {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: 10,
				padding: 20,
				color: 'var(--text-dim)',
			}}
			role="status"
			aria-live="polite"
		>
			<span className="spinner" />
			{label && <span style={{ fontSize: 13 }}>{label}</span>}
		</div>
	);
}
